import angular from 'angular';

import gridHeight from '../../core/shared-service/grid-utils';

class PrincipalGroupCtrl {
    /*@ngInject*/
    constructor(PrincipalSvc, CompanyService, logger, $state, AuthSvc, TYPEGROUPE) {
        this.PrincipalSvc = PrincipalSvc;
        this.CompanyService = CompanyService;
        this.logger = logger;
        this.$state = $state;
        this.AuthSvc = AuthSvc;
        this.TYPEGROUPE = TYPEGROUPE;
    }

    $onInit() {
        this.headerTemplate = require('../principal-header-info.html');

        var ctrl = this;
        this.criteria = {};
        this.subEntityValue = '';

        // Gestion de la grille
        var defaultCellTemplate = `<a class="grid-cell-link"><div class="ui-grid-cell-contents" ng-class="row.entity.isDefaultGroup() ? 'legal-entity-group-all' : 'ui-grid-cursor-pointer'" ng-click="grid.appScope.$ctrl.edit(row.entity)">{{COL_FIELD CUSTOM_FILTERS}}</div></a>`;
        var sortWithGroupAllFirst = function (a, b, rowA, rowB, direction) {
            var d;
            if (rowA.entity.type === 'ALL' || a === null || a === undefined) {
                d = direction === 'asc' ? -1 : 1;
            } else if (rowB.entity.type === 'ALL' || b === null || b === undefined) {
                d = direction === 'asc' ? 1 : -1;
            } else if (typeof a === 'number') {
                d = a - b;
            } else {
                d = a.toString().toLowerCase().localeCompare(b.toString().toLowerCase());
            }
            return d;
        };
        this.gridOptions = {
            columnDefs: [
                {
                    name: 'name',
                    displayName: 'Groupe',
                    sort: { direction: 'asc', priority: 0 },
                    cellTemplate: defaultCellTemplate,
                    sortingAlgorithm: sortWithGroupAllFirst,
                },
                {
                    name: 'description',
                    displayName: 'Description',
                    cellTemplate: defaultCellTemplate,
                    sortingAlgorithm: sortWithGroupAllFirst,
                    width: 600,
                },
                {
                    name: 'nbLegalEntities',
                    displayName: 'Entités Juridiques',
                    cellClass: 'cell-number',
                    cellTemplate: defaultCellTemplate,
                    sortingAlgorithm: sortWithGroupAllFirst,
                    width: 200,
                },
                {
                    name: 'nbSubEntities',
                    displayName: 'Etablissements',
                    cellClass: 'cell-number',
                    cellTemplate: defaultCellTemplate,
                    sortingAlgorithm: sortWithGroupAllFirst,
                    width: 200,
                },
            ],
            paginationPageSize: 10,
            paginationPageSizes: [10, 50],
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
            onRegisterApi: function (gridApi) {
                ctrl.gridApi = gridApi;
            },
        };
        this.searchGroups();
    }

    getNameIdentifier(val) {
        return this.CompanyService.autocompleteNameId({
            principalId: this.principal.detail.id,
            data: val,
        }).$promise.then(function (result) {
            return result;
        });
    }

    /**
     * Autocomplete pour subEntiy
     * @param {*} val
     */
    getSubEntityNameIdentifier(val) {
        return this.PrincipalSvc.autoCompleteGetAllSubEntityDOPermiter({ id: this.principal.detail.id, data: val });
    }

    /**
     * Réinitialise les filtres.
     */
    clear() {
        this.criteria.groupName = null;
        this.criteria.companyValue = null;
        this.criteria.subEntityCode = null;
        this.criteria.types = null;
        this.subEntityValue = null;
    }

    /**
     * Lance la recherche des groupes.
     */
    searchGroups() {
        if (this.subEntityValue) {
            this.criteria.subEntityCode = this.subEntityValue.code;
        }
        /** Type du groupe : (ALL, STANDARD,INVITED_SELLER). */
        this.criteria.types = [this.TYPEGROUPE.all, this.TYPEGROUPE.standard]
        this.groupPromise = this.PrincipalSvc.searchGroups(this.principal.detail.id, this.criteria);
        this.groupPromise.then(
            groups => {
                this.gridOptions.data = groups;
                this.gridOptions.totalItems = groups.length;
            },
            () => this.logger.error('error.search')
        );
    }

    /**
     * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
     */
    getGridHeight() {
        return gridHeight(this.gridApi);
    }

    /** Redirige vers la page de création */
    goToCreation() {
        this.$state.go('app.principal.consult.group-creation');
    }

    edit(group) {
        if (group && group.type !== 'ALL') {
            if (group.nbSubEntities > 0) {
                this.$state.go('app.principal.consult.group-sub-entity-edit', { groupId: group.id });
            } else {
                this.$state.go('app.principal.consult.group-edit', { groupId: group.id });
            }
        }
    }

    isSupportAuthorized() {
        return this.AuthSvc.isAuthorized('SUPPORT');
    }
}

angular.module('app.principal').component('principalGroup', {
    templateUrl: require('./principal-group.html'),
    controller: PrincipalGroupCtrl,
    bindings: {
        principal: '<',
    },
});
